import { createApi } from '@reduxjs/toolkit/query/react';
import { List } from 'immutable';
import Step from 'models/Tools/Step';
import { axiosBaseQuery } from 'services/api';
import { WORKSPACE_TAG, workspaceApi } from './workspaceApi';

export const STEPS_TAG = 'Steps';

export const stepsApi = createApi({
  reducerPath: 'stepsApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/api/project-program-tools-steps/',
  }),
  tagTypes: [STEPS_TAG],
  endpoints: builder => ({
    listSteps: builder.query({
      // Usage: useListStepsQuery({ project: projectId, program: programId})
      query: params => ({
        method: 'GET',
        params,
      }),
      transformResponse: response => List(response.map(item => new Step(item))),
      providesTags: [STEPS_TAG],
    }),
    fetchStep: builder.query({
      // Support both usages:
      // 1. fetchStep(stepId) - just fetch step data and validate the step
      // 2. fetchStep({ stepId, projectId, shouldRefetchWorkspace: true }) - validate the step and refetch workspace data -> useValidateStep()
      query: ({ stepId }) => ({
        url: `${stepId}/`,
        method: 'GET',
      }),
      transformResponse: response => new Step(response),
      providesTags: [STEPS_TAG],

      async onQueryStarted({ shouldRefetchWorkspace, projectId }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;

          // Invalidate cache tags for workspace (refetch) if explicitly requested through useValidateStep() custom hook for step validation
          if (shouldRefetchWorkspace && projectId) {
            dispatch(workspaceApi.util.invalidateTags([WORKSPACE_TAG]));
          }
        } catch {
          // Query failed, no workspace refetch
        }
      },
    }),
    updateStep: builder.mutation({
      query: ({ id, project, program, ...step }) => ({
        url: `${id}/`,
        method: 'PATCH',
        params: { project, program },
        data: step,
      }),
      invalidatesTags: [STEPS_TAG],
    }),
  }),
});

export const {
  useListStepsQuery,
  useFetchStepQuery,
  useLazyFetchStepQuery,
  useUpdateStepMutation,
} = stepsApi;
